import getProductsContent from './getProductsContent'

const products = {
  getProductsContent
}

export default products
